import React, { useState,useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,FormControl,MenuItem,Select,InputLabel,TablePagination
} from "@mui/material";
import { Add, Edit, Delete, Link, Close } from "@mui/icons-material"; // Import Close icon


import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch,useDelete,useUpdate } from "../../hooks";

import SnackbarComponent from "../../components/SnackBar/snackBar";

const AdminRibbion = () => {
  const [rows, setRows] = useState([]);
const [isModalOpen, setModalOpen] = useState(false);
 const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
const [ribbonNameError, setRibbonNameError] = useState("");

   const [snackbarState, setSnackbarState] = useState({
        open: false,
        severity: 'success', // Default severity
        message: '',
        position: { vertical: 'top', horizontal: 'center' },
      });
    const loginToken=useSelector((state)=>state.user.logintoken)

     useEffect(()=>{
        fetchData()
          },[])

      const {data:ribbonData,isLoading:isRibbonLoading,error,fetchData} = useFetch(BASE_URL_TEST+urls('getAllRibbons'),{
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            "Authorization":loginToken ? `Bearer ${loginToken}`:''
        }
      })


        const {data:createRibbonsData,error:createRibbonsError,fetchData:fetchCreateData} = useFetch(BASE_URL_TEST+urls('createRibbons'),{
          method: 'POST',
          headers: { 
            
              "Authorization":loginToken ? `Bearer ${loginToken}`:''
          }
        })


         useEffect(()=>{
            if(createRibbonsError)  
            {
        
            }else if(createRibbonsData && createRibbonsData['status']===true)
            {
              setSnackbarState({...snackbarState,open:true,message:createRibbonsData['message'],position:{ vertical: 'top', horizontal: 'center' },severity:'success'})
              setModalOpen(false);
              fetchData()
            }
        
          },[createRibbonsData,createRibbonsError])


 useEffect(()=>{
    if(error)
    {

    }else if(ribbonData && ribbonData['status']===true)
    {
      // console.log("ribbonData",ribbonData['data'])
      // setRows(ribbonData['data'])
      const ribbonOnly = ribbonData['data'].filter(item => item.type === 'ribbon');
      setRows(ribbonOnly);
    }

  },[ribbonData,error])


    const {data:updatedRibbonsData,error:updatedRibbonsError,updateData:fetchUpdateData} = useUpdate(BASE_URL_TEST,{
      method: 'PUT',
      headers: { 
        
          "Authorization":loginToken ? `Bearer ${loginToken}`:''
      }
    })

      const {data:deletedRibbonsData,error:deletedRibbonsError,deleteData:fetchDeleteData} = useDelete(BASE_URL_TEST,{
        method: 'DELETE',
        headers: { 
            "Authorization":loginToken ? `Bearer ${loginToken}`:''
        }
      })

      const getCurrentPageData = () => {
        const startIndex = page * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        return rows.slice(startIndex, endIndex);
    };

      const handlePageChange = (event, newPage) => {
        setPage(newPage);

      };
    
      const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };
    

       useEffect(()=>{
          if(deletedRibbonsError)
          {
      
          }
          else if(deletedRibbonsData && deletedRibbonsData['status']===true)
          {
            setSnackbarState({...snackbarState,open:true,message:deletedRibbonsData['message'],position:{ vertical: 'top', horizontal: 'center' },severity:'success'})
            setModalOpen(false);
            setSelectedRows([])
            fetchData()
          }
      
        },[deletedRibbonsData,deletedRibbonsError])


    useEffect(()=>{
      if(updatedRibbonsError)
      {
  
      }else if(updatedRibbonsData && updatedRibbonsData['status']===true)
      {
        console.log("updatedRibbonsData",updatedRibbonsData)
        
        setSnackbarState({...snackbarState,open:true,message:updatedRibbonsData['message'],position:{ vertical: 'top', horizontal: 'center' },severity:'success'})
        setModalOpen(false);
        setSelectedRows([]);
        fetchData()
      }
  
    },[updatedRibbonsData,updatedRibbonsError])


  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  // const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [newRibbon, setNewRibbon] = useState({
    id: "",
    image: "",
    name: "",
    date: "",
    status: true,
    imageFile: null, // Store the uploaded image file
  });




  // Handle Search
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  // const filteredRows = rows.filter((row) =>
  //   row.name.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const filteredData = searchTerm
  ? rows.filter(item =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.description.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : rows;

  // Handle Checkbox Selection
  // const handleSelectRow = (id) => {
  //   setSelectedRows((prev) =>
  //     prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
  //   );
  // };

  // Activate Rows
  const handleActivate = () => {
   
    console.log("currenRibbon",newRibbon)

    
    selectedRows.forEach(async (item) => {
      console.log("Active item:", item);
      
      const formdata = new FormData();
      formdata.append("name", item['name']); 
      formdata.append("type", 'ribbon');
      formdata.append("description", 'testing');
      formdata.append("badgeImage", item['image_url']); 
      formdata.append("triggerType", "null");
      formdata.append("apporval", "null");
      formdata.append("status", 1); 
  
      const updateUrl = urls('updateRibbons', item['badge_id']); 
      
      try {
          const response = await fetchUpdateData(updateUrl, formdata);
          console.log(`Badge ${item.badge_id} updated successfully`, response);
      } catch (error) {
          console.error(`Error updating badge ${item.badge_id}`, error);
      }
  });
  
       
    
 
    console.log("selectedRowsAc",selectedRows)
    
  };

  

  // Deactivate Rows
  const handleDeactivate = () => {
    selectedRows.forEach(async (item) => {
      console.log("Active item deac:", item);
      
      const formdata = new FormData();
      formdata.append("name", item['name']); 
      formdata.append("type", 'ribbon');
      formdata.append("description", 'testing');
      formdata.append("badgeImage", item['image_url']); 
      formdata.append("triggerType", "null");
      formdata.append("apporval", "null");
      formdata.append("status",0); 
  
      const updateUrl = urls('updateRibbons', item['badge_id']); 
      
      try {
          const response = await fetchUpdateData(updateUrl, formdata);
          console.log(`Badge ${item.badge_id} updated successfully`, response);
      } catch (error) {
          console.error(`Error updating badge ${item.badge_id}`, error);
      }
  });
    setSelectedRows([]);
  };

  // Delete Rows
  const handleDelete = (id) => {
   
    console.log("selectedDelted",id)

      const deleteUrl = urls('deleteRibbons', id); 
          
        fetchDeleteData(deleteUrl)  
  };

  const handleMultiDelete = (selectedData) => {
      console.log("selectedData",selectedData)
      if(selectedData && selectedData.length>0)
      {
       selectedData.forEach(async (item) => {
          console.log("Delete item multiple:", item);
          const deleteUrl = urls('deleteRibbons', item.badge_id);
          
          try {
              const response = await  fetchDeleteData(deleteUrl);
              console.log(`Ribbon ${item.badge_id} Deleteed successfully`, response);
          } catch (error) {
              console.error(`Error updating badge ${item.badge_id}`, error);
          }
      });

        fetchData()
       
        
      } 
    
      setSelectedRows([]);
    };



  // Handle Dialog Open/Close
  const handleDialogOpen = (data, isEdit = false) => {
    setIsEditMode(isEdit);
    if (isEdit) {
      console.log("ribbbon data",data)
      setNewRibbon(data);
    } else {
      setNewRibbon({
        id: "",
        image: "",
        name: "",
        date: "",
        status: true,
        imageFile: null,
      });
    }
    setDialogData(data);
    setModalOpen(true);
  };

  const handleDialogClose = () => {
    setModalOpen(false);
    setDialogData(null);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewRibbon((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNewRibbon((prev) => ({
        ...prev,
        imageFile: file,
        image: URL.createObjectURL(file), // Preview the image
      }));
    }
  };

  const handleSave = () => {
    if (isEditMode) {
   
        console.log("currenRibbon",newRibbon)
       
            const formdata = new FormData();
            formdata.append("name", newRibbon['name']);
            formdata.append("type", 'ribbon');
            formdata.append("description", 'testing');
            formdata.append("badgeImage", newRibbon['imageFile']);
            formdata.append("triggerType", "null");
            formdata.append("apporval", "null");
            formdata.append("status", newRibbon['status']);
      
          const updateUrl = urls('updateRibbons', newRibbon['badge_id']); 
          fetchUpdateData(updateUrl,formdata);
    } 
    else {
      if (!newRibbon['name'].trim()) {
        setRibbonNameError("Ribbon name is required");
        return;
      }  else {
        const formdata = new FormData();
formdata.append("name", newRibbon['name']);

formdata.append("type", 'ribbon');
formdata.append("description", 'testing');
formdata.append("badgeImage", newRibbon['imageFile']);
formdata.append("triggerType", "null");
formdata.append("apporval", "null");

fetchCreateData(formdata)
      }

     
    }
    setModalOpen(false);
    setNewRibbon({
      id: "",
      image: "",
      name: "",
      date: "",
      status: true,
      imageFile: null,
    });
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  const handleSelectRow = (row) => {
    console.log("rowdsles",row)
    setSelectedRows((prevSelected) => {
      
      const isSelected = prevSelected.some(
        (selectedRow) => selectedRow.badge_id === row.badge_id
      );
  
      
      if (isSelected) {
        return prevSelected.filter(
          (selectedRow) => selectedRow.badge_id !== row.badge_id
        );
      } else {
        return [...prevSelected, row];
      }
    });
  };
  // console.log("selectedRows",selectedRows)


  return (
    <Box sx={{ padding: 3, backgroundColor: "#F9FAFC" }}>
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={2}
      >
        <Typography variant="h6">Ribbons</Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          color="primary"
          onClick={() => handleDialogOpen(null, false)}
        >
          New
        </Button>
      </Box>

      {/* Search and Actions */}
      <Box display="flex" gap={2} marginBottom={2}>
        <TextField
          variant="outlined"
          placeholder="Search by ribbon name"
          size="small"
          value={searchTerm}
          onChange={handleSearch}
          fullWidth
        />
        <Button variant="contained" color="primary">
          Search
        </Button>
        <Button variant="outlined" onClick={handleActivate}>
          Activate
        </Button>
        <Button variant="outlined" onClick={handleDeactivate}>
          Deactivate
        </Button>
        <Button
          variant="outlined"
          color="error"
          sx={{display:'none'}}
          onClick={() => handleMultiDelete(selectedRows)}
        >
          Delete
        </Button>
      </Box>

 <Box>
                {isRibbonLoading ? (
                  <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                    <CircularProgress />
                  </Box>
                ) : null}
              </Box>


              

      {/* Table */}
     <TableContainer
        component={Paper}
        sx={{ borderRadius: "20px", borderRadius: 2, boxShadow: 2 }}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={
                    selectedRows.length > 0 && selectedRows.length < rows.length
                  }
                  checked={selectedRows.length === rows.length}
                  onChange={() =>
                    setSelectedRows(
                      selectedRows.length === rows.length
                        ? []
                        : rows.map((row) => row.id)
                    )
                  }
                />
              </TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "bold",display:'none ' }}>Added On</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {filteredData.length > 0 ? (
  filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  //         {getCurrentPageData().length > 0 ? (
  // getCurrentPageData().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    .filter((row) => row.type === "ribbon") // Only include type "ribbon"
    .map((row) => {
      console.log("0-badgeid",selectedRows,typeof row.badge_id,selectedRows.includes(row.badge_id))
      return(
        <TableRow key={row.badge_id}>
        <TableCell padding="checkbox">
          <Checkbox
            // checked={selectedRows.includes(row.badge_id)}
            checked={selectedRows.some(item => item.badge_id === row.badge_id)} 
            onChange={() => handleSelectRow(row)}
          />
        </TableCell>
        <TableCell>
          {row.image_url ? (
            <img
              src={row.image_url}
              alt="Ribbon"
              style={{ width: 50, height: 50, objectFit: "cover" }}
            />
          ) : (
            <Typography>{row.image_url}</Typography>
          )}
        </TableCell>
        <TableCell>{row.name}</TableCell>
        <TableCell sx={{ display: "none" }}>{row.date}</TableCell>
        <TableCell>
          <Typography
            color={row.status === 1 ? "green" : "gray"}
            fontWeight={"bold"}
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Typography>
        </TableCell>
        <TableCell>
          <IconButton onClick={() => handleDialogOpen(row, true)}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDelete(row.badge_id)} sx={{display:'none'}}>
            <Delete />
          </IconButton>
        </TableCell>
      </TableRow>
      )
    }
      
    
    
    )
) : (
  <TableRow>
    <TableCell colSpan={4} style={{ textAlign: "center" }}>
      No data found for the searched product.
    </TableCell>
  </TableRow>
)}

          </TableBody>
          {/* sameple */}
        </Table>
      </TableContainer> 

       <TablePagination
                      rowsPerPageOptions={[5, 10, 25,50,100]}
                      component="div"
                      count={rows&&rows.length?rows.length:0}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handlePageChange}
                      onRowsPerPageChange={handleRowsPerPageChange}
                    />

{/* <TableContainer
      component={Paper}
      sx={{ borderRadius: "20px", borderRadius: 2, boxShadow: 2 }}
    >
      <Table>
        <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                // indeterminate={
                //   selectedRows.length > 0 && selectedRows.length < rows.length
                // }
                indeterminate={
                  selectedRows.length > 0 && selectedRows.length < rows.length
                }
                checked={selectedRows.length === rows.length}
                onChange={() =>
                  setSelectedRows(
                    selectedRows.length === rows.length
                      ? []
                      : rows.map((row) => row.badge_id)
                  )
                }
              />
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
            <TableCell sx={{ fontWeight: "bold", display: "none" }}>
              Added On
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length > 0 ? (
            rows.map((row) => (
              <TableRow key={row.badge_id}>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedRows.includes(row.badge_id)}
                    onChange={() => handleSelectRow(row)}
                  />
                </TableCell>
                <TableCell>
                  {row.image_url ? (
                    <img
                      src={row.image_url}
                      alt="Ribbon"
                      style={{ width: 50, height: 50, objectFit: "cover" }}
                    />
                  ) : (
                    <Typography>{row.image_url}</Typography>
                  )}
                </TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell sx={{ display: "none" }}>{row.date}</TableCell>
                <TableCell>
                  <Typography
                    color={row.status === 1 ? "green" : "gray"}
                    fontWeight={"bold"}
                  >
                    {row.status === 1 ? "Active" : "Inactive"}
                  </Typography>
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => handleDialogOpen(row, true)}>
                    <Edit />
                  </IconButton>

                  <IconButton
                    color="error"
                    onClick={() => handleDelete(row.badge_id)}
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} style={{ textAlign: "center" }}>
                No data found for the searched product.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
   
    
    </TableContainer> */}

      {/* Dialog for Create/Edit */}
      <Dialog open={isModalOpen} onClose={handleDialogClose}>
        <DialogTitle>
          {isEditMode ? "Edit Ribbon" : "Create Ribbon"}
          {/* Close Icon in the Top-Right Corner */}
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleDialogClose}
            sx={{ position: "absolute", right: 20, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            name="name"
            value={newRibbon.name}
              error={!!ribbonNameError}
                                   helperText={
                                    ribbonNameError && (
                                                      <Typography
                                                        sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                                                      >
                                                        {ribbonNameError}
                                                      </Typography>
                                                    )
                                                  }
            onChange={handleChange}
            sx={{ mb: 5, mt: 2 }}
          />

          {/* Image Upload */}
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            style={{ marginBottom: "16px" }}
          />

          {isEditMode ? 
          ( 
          <FormControl fullWidth sx={{ mb: 5 }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={newRibbon.status || 0} // Default to 0 (Deactive) if status is not set
              onChange={(e) =>
                setNewRibbon((prev) => ({ ...prev, status: e.target.value }))
              }
              label="Status"
            >
              <MenuItem value={1}>Active</MenuItem>
              <MenuItem value={0}>Deactive</MenuItem>
            </Select>
          </FormControl>):null}
          {newRibbon.image_url && (
            <Box
              sx={{
                maxWidth: 100,
                maxHeight: 100,
                overflow: "hidden",
                marginBottom: 2,
              }}
            >
              <img
                src={newRibbon.image_url}
                alt="Uploaded preview"
                style={{ width: "100%", height: "auto" }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            {isEditMode ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminRibbion;
